import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../api/http";
import JobStatusVM from "../types/jobStatus";
import SearchResults from "../types/searchResults";
import SearchParams from "../types/searchParams";
import getSearchQueryString from "../helpers/getSearchQueryString";

interface jobStatusSliceModel {
  jobStatus: JobStatusVM;
  jobStatuses: JobStatusVM[];
  jobStatusSearchResults?: SearchResults;
  status: "idle" | "loading" | "failed";
}

const initialState: jobStatusSliceModel = {
  jobStatus: { id: 0, name: "", icon: "", iconColor: "", order: 0 },
  jobStatuses: [],
  status: "idle",
};

export const getJobStatusId = createAsyncThunk<JobStatusVM, number>(
  "job-status/id/get",
  async (id: number) => {
    const response = await http.get<JobStatusVM>(`/jobstatus/${id}`);
    return response.data;
  }
);

export const getJobStatuses = createAsyncThunk<JobStatusVM[]>(
  "job-status/get",
  async () => {
    const response = await http.get<JobStatusVM[]>(`/jobstatus`);
    return response.data;
  }
);

export const searchJobStatus = createAsyncThunk<SearchResults, SearchParams>(
  "job-status/search",
  async (search: SearchParams) => {
    let qs = getSearchQueryString(search);
    const response = await http.get<SearchResults>(`/jobstatus/search?${qs}`);
    return response.data;
  }
);

const jobStatusSlice = createSlice({
  name: "jobStatus",
  initialState,
  reducers: {
    resetJobStatus(state) {
      state.jobStatus = { ...initialState.jobStatus };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJobStatusId.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getJobStatusId.fulfilled, (state, action) => {
        state.status = "idle";
        state.jobStatus = action.payload;
      })
      .addCase(getJobStatusId.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(getJobStatuses.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getJobStatuses.fulfilled, (state, action) => {
        state.status = "idle";
        state.jobStatuses = action.payload;
      })
      .addCase(getJobStatuses.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(searchJobStatus.pending, (state) => {
        state.status = "loading";
      })
      .addCase(searchJobStatus.fulfilled, (state, action) => {
        state.status = "idle";
        state.jobStatusSearchResults = action.payload;
      })
      .addCase(searchJobStatus.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export default jobStatusSlice.reducer;
export const { resetJobStatus } = jobStatusSlice.actions;
